import React from 'react';
import properties from '../../../modules/ajio-util/properties';

const imageBaseUrl = properties.getProperty('imageBaseUrl');
const parentUrl = properties.getProperty('parentUrl');

export const DealOfTheDayModal = props => {
  let {
    logo = '',
    header = '',
    timer = false,
    subText = '',
    alt = '',
    redirect = false,
    pageRefresh = false,
    modalName = '',
    buttonText = ''
  } = props;
  logo = logo ? imageBaseUrl + logo : '';

  const imageDom = logo ? (
    <div className="dodModal__image">
      <img src={logo} alt={alt || 'Timer icon'} />
    </div>
  ) : (
    ''
  );
  const headerDom = header ? <div className="dodModal__header">{header}</div> : '';

  const timerDom = timer ? (
    <div className="dealOfDay__timer">
      <span className="dealOfDay__timer--header">Ends in &nbsp;</span>
      <div className="dealOfDay__timer--counter">
        <p>
          <span>00</span>h&nbsp;<span>00</span>m&nbsp;<span>00</span>s
        </p>
      </div>
    </div>
  ) : (
    ''
  );
  const subTextDom = subText ? <p className="dodModal__subText">{subText}</p> : '';

  const handleButtonClick = (modalName = '') => () => {
    if (redirect) {
      window.location = parentUrl;
      return;
    }
    if (pageRefresh) {
      window.location.reload();
      return;
    }
    if (modalName === 'deal-out-of-stock') {
      props._isDodStockOver();
    }
    props.hideModal(modalName);
  };
  return (
    <div className="dodModal">
      {imageDom}
      {headerDom}
      {timerDom}
      {subTextDom}
      <button type="button" onClick={handleButtonClick(modalName)}>
        {buttonText || 'Okay'}
      </button>
    </div>
  );
};
